<template>
    <div class="help-menu-wrapper">
        <button title="Help" class="fab m" @click="store.setTutorialVisible(true)">
            <img :src="getMedia('icons/help-circle-outline.svg')" alt="">
        </button>

        <button v-if="languages && languages.length > 1" title="Language" class="fab m" @click="languagePopupVisible = !languagePopupVisible">
            <img :src="getMedia('icons/translate.svg')" alt="">
            <div v-show="languagePopupVisible" class="button-popup" @mouseleave="languagePopupVisible = false">
                <button v-for="(language, index) in languages" :key="index" class="popup-item" :title="t(getLanguageLabel(language))" @click="changeLanguage(language)">
                    {{ t(language) }}
                </button>
            </div>
        </button>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { getMedia } from '@/util';
import { useStore } from '@/store';

const store = useStore();
const { languages, activeLanguage } = storeToRefs(store);

const { t, locale } = useI18n();

const languagePopupVisible = ref(false);

// Update locale when activeLanguage changes
watch(activeLanguage, (newLang) => {
    locale.value = newLang;
});

const getLanguageLabel = (code: string): string => {
    const labels: Record<string, string> = {
        'de': "German",
        'en': "English",
        'fr': "French",
        'it': "Italian",
        'cs': "Czech"
    };
    return labels[code] || code;
};

const changeLanguage = (language: string) => {
    store.setActiveLanguage(language);
};
</script>

<style scoped>
.help-menu-wrapper {
    position: absolute;
    right: 40px;
    bottom: 40px;
    display: flex;
    flex-direction: row-reverse;
    gap: 20px;
}

button[title="Help"],
button[title="Language"] {
    position: relative;
    background: var(--color-blue) !important;
    transition: background .3s ease;
    border: none;
    cursor: pointer;
}

button[title="Help"] img,
button[title="Language"] img {
    max-width: none;
    filter: invert(1);
    width: 80%;
}

button[title="Language"] img {
    width: 60%;
}

button[title="Language"] img.indicator {
    position: absolute;
    top: 0;
    right: 0;
    width: 1.3rem;
    height: 1.3rem;
    transform: translate(30%, -30%);
    filter: invert(0);
    border: 2px solid var(--color-blue);
    border-radius: 50%;
}

.button-popup {
    position: absolute;
    top: 0;
    transform: translate(0, calc(-100% - 10px));
    padding: 10px;
    background-color: var(--bg-light);
    border-radius: 0.25rem;
    min-width: 120px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.button-popup button {
    width: 100%;
    background-color: transparent;
    text-align: left;
    padding: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    border: none;
    cursor: pointer;
    color: inherit;
}

.button-popup button img.flag {
    filter: invert(0);
    height: 24px;
    width: 24px;
}

.button-popup button.popup-item:hover {
    background-color: var(--bg-light-hover);
    color: var(--color-lightblue);
}

@media (width <= 1000px) {
    .help-menu-wrapper {
        right: 24px;
        bottom: 24px;
    }
}
</style>